import { isEmptyInput } from '@adaptiva/core/common';
import { UI } from '@adaptiva/core/ui';
import { BaseWidgetComponent, provideBaseWidget } from '@adaptiva/core/widgets';
import { IconComponent } from '@adaptiva/widgets/icon';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { SpinnerComponent } from '@adaptiva/widgets/spinner';
import { ChangeDetectionStrategy, Component, computed, effect, EffectRef, input, InputSignal, model, ModelSignal, output, OutputEmitterRef, Signal } from '@angular/core';

@Component({
	selector: 'ada-search-navigation',
	templateUrl: './search-navigation.component.html',
	providers: [provideBaseWidget(() => SearchNavigationComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		IconComponent,
		InputComponentModule,
		SpinnerComponent,
	],
	host: {
		'[class.ada-background-color-background-2]': 'true',
		'[class.ada-full-width]': 'true',
		'[class.ada-display-block]': 'true',
		'[class.ada-border-inner-bottom]': 'true',
	},
})
export class SearchNavigationComponent extends BaseWidgetComponent {

	public readonly debounce: InputSignal<int> = input(0);

	public readonly index: ModelSignal<int> = model(0);

	public readonly numberOfMatches: InputSignal<int | null> = input(null);

	public readonly placeholder: InputSignal<string> = input();

	public readonly showNavigation: InputSignal<boolean> = input(true);

	public readonly value: ModelSignal<string> = model();

	public override readonly padding: string = JSON.stringify([
		UI.Spacing.SPACING_SMALL,
		UI.Spacing.SPACING_SMALL,
	]);

	public readonly close: OutputEmitterRef<void> = output();

	protected readonly matchEffect: EffectRef = effect(() => {
		const _numberOfMatches: int = this.numberOfMatches();

		this.index.set(0);
	});

	protected readonly indexDisplay: Signal<int> = computed(() => {
		if (isEmptyInput(this.numberOfMatches(), true))
			return 0;

		return this.index() + 1;
	});

	protected readonly matchDisplayWidth: Signal<string> = computed(() => {
		const _numberOfMatches: int = this.numberOfMatches();

		if (!_numberOfMatches || _numberOfMatches < 9)
			return UI.Spacing.SPACING_LARGE;
		else
			return UI.Spacing.SPACING_XLARGE;
	});

	public next(): void {
		const _index: int = this.index();
		const _numberOfMatches: int = this.numberOfMatches();

		if (isEmptyInput(_numberOfMatches, true))
			return;

		if (_index + 1 === _numberOfMatches)
			this.index.set(0);
		else
			this.index.set(_index + 1);
	}

	public previous(): void {
		const _index: int = this.index();
		const _numberOfMatches: int = this.numberOfMatches();

		if (isEmptyInput(_numberOfMatches, true))
			return;

		if (_index - 1 < 0)
			this.index.set(_numberOfMatches - 1);
		else
			this.index.set(_index - 1);
	}

	public navigateOnSubmit(_event: KeyboardEvent): void {
		if (_event?.key?.toLowerCase() !== 'enter')
			return;

		_event.preventDefault();
		this.next();
	}

}
